export const localDomain = "https://core.feelxr.co/";
export const domain = localDomain;
const assetDomain = localDomain.replace(/\/+$/, "");
export const frontendViewerOrigin = "https://feelxr.co";
export const API = {
  imgUrl: assetDomain,
  getUrls: {
    getPlans: domain + "api/order",
    blogs: domain + "api/blogs",
    services: domain + "api/services",
    Categories: domain + "api/categories",
    getComponents: domain + "api/components/",
    getMaterials: domain + "api/materials",
    getUser: domain + "api/auth/user",
    getProducts: domain + "api/products",
    getSingleProduct: domain + "api/products/",
    productMeta: domain + "api/auth/product_meta",
    variants: domain + "api/variants",
    getUserCat: domain + "api/products/user/categories",
    getSocials: domain + "api/socials",
    getAboutUs: domain + "api/aboutus",
    getPrivacy: domain + "api/privacy",
    getTerms: domain + "api/terms",
    getSubscriptionDetail:
      domain + "api/subscribe/subcsriptionDetailsByProdId/",
    websiteViews: domain + "api/subscribe/websiteViews",
    getRecommendProducts: domain + "api/recommendProducts/",
    getSingleCombination: domain + "api/combinations/single/",
    mapScanUser: domain + "api/map_scan_users/me",
    mapScanModals: domain + "api/map_scan_modals/my-scans",
  },
  postUrls: {
    changeStatus: domain + "api/status/",
    contact: domain + "api/contacts",
    login: domain + "api/auth/signin",
    signUp: domain + "api/auth/signup",
    addproduct: domain + "api/products",
    addComponents: domain + "api/components",
    addMaterial: domain + "api/materials",
    addVariants: domain + "api/variants",
    googleLogin: domain + "api/auth/social_login",
    updateProfile: domain + "api/auth/update_profile",
    postViews: domain + "api/products/product_views",
    deleteAllVariants: domain + "api/products/delete_all_variant",
    chargebeePayment: domain + "api/payment",
    order: domain + "api/order",
    addAnalytics: domain + "api/analytics",
    verifyPasscode: domain + "api/products/verifyProductPasscode",
    mapScanAuth: domain + "api/map_scan_users/auth",
    mapScanModal: domain + "api/map_scan_modals",
  },
  deleteUrls: {
    mapScanModals: domain + "api/map_scan_modals/my-scans",
  },
};

export const getLocalProductUrl = (productId = "") =>
  `${domain}api/products/${productId}`;

export const getLocationMapViewerUrl = (productId = "", markerId = "") => {
  const markerQuery = markerId ? `?marker=${markerId}` : "";
  return `${frontendViewerOrigin}/location-map/modelDynamicviewer/${productId}${markerQuery}`;
};
